import PallangGuideImg1 from '@/assets/images/pallang-guide-1.png';
import PallangGuideImg2 from '@/assets/images/pallang-guide-2.png';
import PallangGuideImg3 from '@/assets/images/pallang-guide-3.png';
import { Card } from '@/components/atoms/Card';

export const PallangGuideImgCard = () => {
  return (
    <Card className="space-y-[30px] p-[30px]">
      {GuideItems.map((item) => (
        <div className="space-y-5">
          <div className="flex items-center justify-between">
            <div className="flex gap-1.5">
              <Badge label={item.number} />
              <div className="mt-px">{item.title}</div>
            </div>
          </div>
          {item.image && (
            <div className="flex justify-center px-[30px]">
              <img src={item.image} className="w-full" />
            </div>
          )}
        </div>
      ))}
    </Card>
  );
};

const Badge = ({ label }: { label: number }) => {
  return (
    <span className=" flex h-[22px] w-[22px] items-center justify-center rounded-[4px]  bg-blue-400 text-[12px] font-bold leading-[18px] text-white">
      {label}
    </span>
  );
};

const GuideItems = [
  {
    number: 1,
    title: (
      <>
        <span
          className="cursor-pointer font-bold"
          onClick={() => window.open('https://business.toss.im/account/sign-in')}
        >
          팔랑 파트너스
        </span>{' '}
        접속
      </>
    ),
  },
  {
    number: 2,
    title: (
      <>
        <span className="font-bold">
          계정 관리 {'>'}
          셀러박스 연동하기
        </span>{' '}
        클릭
      </>
    ),
    image: PallangGuideImg1,
  },
  {
    number: 3,
    title: (
      <>
        <span className="font-bold">OTP 발급받기</span> 클릭
      </>
    ),
    image: PallangGuideImg2,
  },
  {
    number: 4,
    title: (
      <>
        발급 받은 입력 후 <span className="font-bold">OTP 인증코드</span>를 셀러박스에 입력해
        주세요.
      </>
    ),
    image: PallangGuideImg3,
  },
];
